<template>
  <div>
    <div class="col-sm-6">
      <select class="form-control" v-model="stationLineId">
        <option value="">路線を選択</option>
        <option v-for="stationLines in stationLines" :value="stationLines.station_line_id">
          {{stationLines.station_line_name}}
        </option>
      </select>
    </div>
    <div class="col-sm-6">
      <select class="form-control" v-model="stationId">
        <option value="">駅を選択</option>
        <template v-for="station in stations">
          <option :value="station.station_id">
            {{station.station_name}}駅
          </option>
        </template>

      </select>
    </div>
  </div>
</template>
<script>
  import Api from '@/service/Api.vue'

  export default {
    props: ['station_id', 'prefecture_id', 'stationKey'],
    data () {
      return {
        isFirstSearch: false,
        stationLines: [],
        stations: [],
        stationId: '',
        stationLineId: ''
      }
    },
    created: function () {
      console.log('created station_id' + this.station_id)
      if (!this.station_id) {
        this.lineSearch(true)
      } else {
        this.isFirstSearch = true
        this.stationSearch()
      }
    },
    watch: {
      'stationLineId': function (newVal, oldVal) {
        console.log('old' + oldVal)
        console.log('new' + newVal)
        var isFirst = oldVal || false
        console.log('isFirst ' + isFirst)
        if (!this.isFirstSearch) {
          this.stationId = ''
          this.stations = []
          this.stationSearch()
        } else {
          this.isFirstSearch = false
        }
      },
      'stationId': function (val) {
        this.$emit('update', {
          key: this.stationKey,
          stationId: val
        })
      }
    },
    methods: {
      lineSearch: function (searchStation) {
        var self = this
        Api.stationLine.search({
          'prefecture_id': this.prefecture_id
        }).then(function (response) {
          self.stationLines = response.data.station_lines
          if (searchStation) {
            self.stationSearch()
          }
        })
      },
      stationSearch: function () {
        var self = this
        if (this.stationLineId === '' && !this.station_id) {
          return
        }
        var data = {}
        if (this.stationLineId) {
          data.station_line_id = this.stationLineId
          data.station_id = ''
          Api.station.search(data).then(function (response) {
            self.stations = response.data.stations
            self.stationId = ''
          })
        } else {
          data.station_id = this.station_id
          data.line = true
          console.log('API送信前')
          console.log(data)
          Api.station.search(data).then(function (response) {
            self.stations = response.data.stations
            self.stationId = ''
            self.stationId = data.station_id
            console.log('再設定 station_id' + self.stationId)
            self.stations.forEach(function (val) {
              self.stationLineId = val.station_line_id
            })
            self.lineSearch(false)
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SelectStationRow.vue?65f2e954